import { TabConfig } from './types';

export const TYPE_OPTIONS = ['Category', 'Illustrator'];

export const CHART_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8'];

export const TAB_CONFIGS: TabConfig[] = [
  {
    label: 'Writing Genres',
    categoryKey: 'writing-genres',
    toggleCategory: 'writing-genre',
    styleType: 'writing',
    popularField: 'writing',
    popularValue: 'genre',
  },
  {
    label: 'Writing Authors',
    categoryKey: 'writing-authors',
    toggleCategory: 'writing-author',
    styleType: 'writing',
    popularField: 'writing',
    popularValue: 'author',
  },
  {
    label: 'Illustration Styles',
    categoryKey: 'illustration-art-styles',
    toggleCategory: 'illustration-style',
    styleType: 'illustration',
    popularField: 'illustration',
    popularValue: 'style',
  },
  {
    label: 'Illustration Artists',
    categoryKey: 'illustration-artists',
    toggleCategory: 'illustration-artist',
    styleType: 'illustration',
    popularField: 'illustration',
    popularValue: 'artist',
  },
];

// Category pill colors
export const CATEGORY_PILL_COLORS: Record<string, { bg: string; color: string }> = {
  Genre: { bg: '#1A5F7A', color: '#fff' },
  Author: { bg: '#D4AC0D', color: '#fff' },
  Style: { bg: '#1A5F7A', color: '#fff' },
  Artist: { bg: '#7D1935', color: '#fff' },
};
